module.exports = __webpack_public_path__ + "static/Intelligent-Resilient-Supply-Chain-aaa3f1d693fe5f022f7e409bfc49f917.jpg";